module.exports = __webpack_public_path__ + "img/moments-box-img-m.c80ba0de.png";